import { render, staticRenderFns } from "./cancelTrash.vue?vue&type=template&id=1fc207e5"
import script from "./cancelTrash.vue?vue&type=script&lang=js"
export * from "./cancelTrash.vue?vue&type=script&lang=js"
import style0 from "./cancelTrash.vue?vue&type=style&index=0&id=1fc207e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports